import { AxiosResponse } from 'axios';

import { PatchPersonalInformationPayload } from 'api/Address/interfaces';
import httpRequest from 'api/base';
import HTTPEndPoints from 'api/httpEndpoints';
import { HTTPVerbs } from 'api/types';

import {
  ApplicationDetailBranchPatchPayload,
  ApplicationDetailBranchPatchResponse,
  ApplicationDetailPatchPayload,
  ApplicationDetailResponse,
  ApplicationDetailsConfirmPayload,
  ApplicationDetailsConfirmResponse,
  ChangePhoneNumberPayload,
  GetApplicationHistoryResponse,
  GetSurveyorDetailsResponse,
  GetVerifyApplicationStatusResponse,
  PatchApplicationStatusBlackListPayload,
  PostLeadReviveResponse,
} from './interfaces';

const getApplicationDetail = async (
  applicationId: string,
): Promise<AxiosResponse<ApplicationDetailResponse>> => {
  const path = HTTPEndPoints.getApplicationDetail(applicationId);
  const method = HTTPVerbs.GET;
  const result = await httpRequest({ path, method });
  return result.data;
};

const patchApplicationDetail = async (
  applicationId: string,
  data: ApplicationDetailPatchPayload,
): Promise<AxiosResponse<ApplicationDetailResponse>> => {
  const path = HTTPEndPoints.patchApplicationDetail(applicationId);
  const method = HTTPVerbs.PATCH;
  const result = await httpRequest({ path, method, data });
  return result.data;
};

const patchApplicationBranchDetail = async (
  applicationId: string,
  data: ApplicationDetailBranchPatchPayload,
): Promise<AxiosResponse<ApplicationDetailBranchPatchResponse>> => {
  const path = HTTPEndPoints.patchApplicationDetail(applicationId);
  const method = HTTPVerbs.PATCH;
  const result = await httpRequest({ path, method, data });
  return result.data;
};

const postApplicationDetailsConfirm = async (
  data: ApplicationDetailsConfirmPayload,
): Promise<AxiosResponse<ApplicationDetailsConfirmResponse>> => {
  const path = HTTPEndPoints.postApplicationDetailsConfirm(data.application_id);
  const method = HTTPVerbs.POST;
  const result = await httpRequest({ path, method, data });
  return result.data;
};

const postUpdateApplicationStatus = async (
  applicationId: string,
  status: string,
) => {
  const path = HTTPEndPoints.postUpdateApplicationStatus(applicationId, status);
  const method = HTTPVerbs.POST;
  const result = await httpRequest({ path, method });
  return result;
};

const patchUpdateApplicationStatusBlackList = async (
  data: PatchApplicationStatusBlackListPayload,
  applicationId: string,
) => {
  const path =
    HTTPEndPoints.patchUpdateApplicationStatusBlackList(applicationId);
  const method = HTTPVerbs.PATCH;
  const result = await httpRequest({ path, method, data });
  return result;
};

const putChangePhoneNumber = async (
  applicationId: string,
  data: ChangePhoneNumberPayload,
) => {
  const path = HTTPEndPoints.putChangePhoneNumber(applicationId);
  const method = HTTPVerbs.PUT;
  const result = await httpRequest({ path, method, data });
  return result;
};

const getVerifyApplicationStatus = async (
  applicationId: string,
  applicationStatus: string,
): Promise<AxiosResponse<GetVerifyApplicationStatusResponse>> => {
  const path = HTTPEndPoints.getVerifyApplicationStatus(
    applicationId,
    applicationStatus,
  );
  const method = HTTPVerbs.GET;
  const result = await httpRequest({ path, method });
  return result.data;
};

const getSurveyorDetails = async (
  applicationId: string,
): Promise<AxiosResponse<GetSurveyorDetailsResponse>> => {
  const path = HTTPEndPoints.getSurveyorDetails(applicationId);
  const method = HTTPVerbs.GET;
  const result = await httpRequest({ path, method });
  return result.data;
};

const patchApplicationPersonalInfo = async (
  applicationId: string,
  data: PatchPersonalInformationPayload,
): Promise<AxiosResponse<ApplicationDetailResponse>> => {
  const path = HTTPEndPoints.patchApplicationPersonalInfo(applicationId);
  const method = HTTPVerbs.PATCH;
  const result = await httpRequest({ path, method, data });
  return result.data;
};

const postLeadRevive = async (
  groupId: string,
): Promise<AxiosResponse<PostLeadReviveResponse>> => {
  const path = HTTPEndPoints.postLeadRevive(groupId);
  const method = HTTPVerbs.POST;
  const result = await httpRequest({ path, method });
  return result.data;
};

const getApplicationHistory = async (
  applicationId: string,
): Promise<AxiosResponse<GetApplicationHistoryResponse>> => {
  const path = HTTPEndPoints.getApplicationHistory(applicationId);
  const method = HTTPVerbs.GET;
  const result = await httpRequest({ path, method });
  return result.data;
};

const ApplicationAPI = {
  getApplicationDetail,
  getApplicationHistory,
  getSurveyorDetails,
  getVerifyApplicationStatus,
  patchApplicationBranchDetail,
  patchApplicationDetail,
  patchApplicationPersonalInfo,
  postApplicationDetailsConfirm,
  postLeadRevive,
  postUpdateApplicationStatus,
  patchUpdateApplicationStatusBlackList,
  putChangePhoneNumber,
};

export default ApplicationAPI;
